module.exports = __webpack_public_path__ + "img/404.eef29b67.svg";